import type { InputHTMLAttributes, ReactNode } from "react";

import { cn } from "@utils/tailwind.util";

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  labelClass?: string;
  variant?: "small" | "medium";
  isChecked?: boolean;
  labelVariant?: "small" | "medium";
}

export function Radio({
  id,
  label,
  labelClass,
  variant = "medium",
  isChecked = false,
  className = "",
  labelVariant = "medium",
  ...restInputProps
}: RadioProps) {
  return (
    <div className="min-w-0 flex items-center">
      <input
        checked={isChecked}
        id={id}
        type="radio"
        value=""
        name="default-radio"
        className={cn(
          className,
          "h-4 w-4",
          { "h-3 w-3": variant === "small" },
          "appearance-none shrink-0 rounded-full",
          "focus:outline-none focus:ring-0 focus:ring-offset-0 focus:outline-offset-0",
          "hover:outline-stroke-secondary hover:bg-stroke-disabled disabled:cursor-not-allowed disabled:outline-stroke-disabled disabled:bg-stroke-disabled",
          "checked:bg-teal-400 checked:focus:bg-teal-400 checked:hover:bg-teal-500 checked:border-teal-500",
          "dark:bg-gray-600 dark:checked:bg-teal-400 dark:border-gray-500 dark:checked:focus:outline-1 dark:checked:focus:outline-teal-200"
        )}
        {...restInputProps}
      />
      {label && (
        <label
          htmlFor={id}
          className={cn(
            { "text-sm font-normal text-text-primary": labelVariant === "small" },
            { "font-medium text-gray-700": labelVariant === "medium" },
            { "ml-3": variant === "medium" },
            { "ml-2 text-sm text-gray-600": variant !== "medium" },
            { "text-content-disabled": restInputProps.disabled },
            labelClass
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
}
